"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionServiceStub = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const faker_1 = __importDefault(require("faker"));
const stubDistribution = (companyId, overrides = {}) => ({
    _id: `distributions-${faker_1.default.random.uuid()}`,
    companyId,
    name: faker_1.default.commerce.productName(),
    status: "draft",
    periodPaidFrom: new Date("2026-01-01"),
    periodPaidTo: new Date("2026-03-31"),
    paymentDate: new Date("2026-04-15"),
    components: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    ...overrides,
});
class DistributionServiceStub {
    async getDistributions(companyId, _query) {
        return {
            status: true,
            message: "ok",
            payload: {
                items: [stubDistribution(companyId)],
                total: 1,
                summary: {
                    totalCount: 1,
                    paidToDateCents: 0,
                    awaitingExecutionCount: 0,
                    draftCount: 1,
                },
            },
        };
    }
    async getDistributionStatement(_companyId, _distributionId, _shareholderId, _timestamp) {
        return {
            status: true,
            message: "ok",
            payload: Buffer.from("stub-distribution-statement-pdf").toString("base64"),
        };
    }
    async getShareholderDistributions(_companyId, _shareholderId) {
        return {
            status: true,
            message: "ok",
            payload: [
                {
                    distributionId: `distributions-${faker_1.default.random.uuid()}`,
                    name: "Q1 2026 income distribution",
                    paymentDate: new Date("2026-05-29"),
                    periodPaidFrom: new Date("2026-03-31"),
                    periodPaidTo: new Date("2026-03-31"),
                    isSuspended: false,
                    unpaidReason: null,
                    settledByDistributionId: null,
                    settledBySettlementId: null,
                },
            ],
        };
    }
    async getDistribution(companyId, distributionId) {
        return {
            status: true,
            message: "ok",
            payload: stubDistribution(companyId, { _id: distributionId }),
        };
    }
    async createDistribution(companyId, body) {
        return {
            status: true,
            message: "ok",
            payload: stubDistribution(companyId, { name: body.name, components: body.components }),
        };
    }
    async updateDistribution(companyId, distributionId, body) {
        return {
            status: true,
            message: "ok",
            payload: stubDistribution(companyId, { _id: distributionId, ...body }),
        };
    }
    async deleteDistribution(_companyId, _distributionId) {
        return { status: true, message: "ok", payload: null };
    }
    async getDistributionPreview(_companyId, _distributionId) {
        return {
            status: true,
            message: "ok",
            payload: {
                summary: {
                    enteredGrossCents: 0,
                    suspendedGrossCents: 0,
                    residualCents: 0,
                    netPayableCents: 0,
                    perComponent: [],
                    totals: {
                        grossCents: 0,
                        taxCents: 0,
                        netCents: 0,
                        payoutCount: 0,
                        reinvestCount: 0,
                        unpaidCents: 0,
                        unpaidCount: 0,
                    },
                },
                allocations: [],
                taxSummary: { published: false, undefinedCount: 0 },
                abaPreview: {
                    excerptLines: [],
                    payoutCount: 0,
                    totalCreditCents: 0,
                    totalRecordCount: 0,
                },
            },
        };
    }
    async getDistributionCsvData(_companyId, _distributionId) {
        return {
            status: true,
            message: "ok",
            payload: [
                {
                    shareholderId: faker_1.default.random.uuid(),
                    name: faker_1.default.name.findName(),
                    unitClassId: faker_1.default.random.uuid(),
                    unitsHeld: "100",
                    grossCents: 10000,
                    taxWithheldCents: 0,
                    netCents: 10000,
                    treatment: "payout",
                    status: "payable",
                },
            ],
        };
    }
    async confirmDistribution(companyId, distributionId, body) {
        return {
            status: true,
            message: "ok",
            payload: stubDistribution(companyId, {
                _id: distributionId,
                status: "pending",
                publishDate: body.publishDate,
                notificationPreferences: body.notificationPreferences,
                confirmedAt: new Date(),
            }),
        };
    }
    async setDistributionAdminBlock(_companyId, _distributionId, params) {
        return {
            status: true,
            message: "ok",
            payload: { adminBlockedShareholderIds: params.blocked ? [params.shareholderId] : [] },
        };
    }
    async getDistributionAbaFile(_companyId, _distributionId) {
        return {
            status: true,
            message: "ok",
            payload: {
                filename: "distribution.aba",
                contentBase64: Buffer.from("stub-aba").toString("base64"),
                totals: { creditCount: 0, netTotalCents: 0 },
            },
        };
    }
    getDistributionManualPayments(_companyId, _distributionId) {
        return Promise.resolve({ status: true, message: "ok", payload: { rows: [], totalCents: 0 } });
    }
    async completeDistribution(_companyId, distributionId, publishDate) {
        return {
            status: true,
            message: "ok",
            payload: {
                distributionId,
                completedAt: new Date().toISOString(),
                publishDate: publishDate?.toISOString() ?? null,
                transactionsCreated: 0,
                transactionsSkipped: 0,
                reinvestment: null,
            },
        };
    }
    async getDistributionTransactions(_companyId, _distributionId) {
        return {
            status: true,
            message: "ok",
            payload: {
                rows: [
                    {
                        shareholderId: `shareholders-${faker_1.default.random.uuid()}`,
                        investorName: faker_1.default.company.companyName(),
                        unitClassId: `shareclasses-${faker_1.default.random.uuid()}`,
                        unitClassName: "Ordinary Units",
                        quantity: "1000",
                        grossCents: 50000,
                        taxCents: 0,
                        netCents: 50000,
                        amountPaidCents: 50000,
                        amountUnpaidCents: 0,
                        outcome: "bank_payout",
                        category: "payout",
                        unpaidReason: null,
                        dateOfTransaction: new Date("2026-04-15"),
                    },
                    {
                        shareholderId: `shareholders-${faker_1.default.random.uuid()}`,
                        investorName: faker_1.default.company.companyName(),
                        unitClassId: `shareclasses-${faker_1.default.random.uuid()}`,
                        unitClassName: "Ordinary Units",
                        quantity: "800",
                        grossCents: 40000,
                        taxCents: 0,
                        netCents: 40000,
                        amountPaidCents: 0,
                        amountUnpaidCents: 40000,
                        outcome: "unpaid_suspended",
                        category: "suspended",
                        unpaidReason: "not_on_register",
                        dateOfTransaction: null,
                    },
                ],
                summary: {
                    grossCents: 90000,
                    taxCents: 0,
                    netCents: 90000,
                    payoutCount: 1,
                    reinvestCount: 0,
                    unpaidCount: 1,
                    unpaidCents: 40000,
                    bankPayoutCents: 50000,
                    reinvestedCents: 0,
                },
            },
        };
    }
}
exports.DistributionServiceStub = DistributionServiceStub;
//# sourceMappingURL=DistributionServiceStub.js.map